import { render, staticRenderFns } from "./RiaperturaMaster.vue?vue&type=template&id=2368a7f3&scoped=true&"
import script from "./RiaperturaMaster.vue?vue&type=script&lang=js&"
export * from "./RiaperturaMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2368a7f3",
  null
  
)

export default component.exports